import React from 'react';
import { Modal } from './Modal';
import { Button } from './ui/button';

interface SignOutConfirmationModalProps {
  isOpen: boolean;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

export const SignOutConfirmationModal: React.FC<SignOutConfirmationModalProps> = ({
  isOpen,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Sign Out"
      size="sm"
      closeOnBackdrop={!isLoading}
      footer={(
        <>
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={isLoading}
            data-testid="signout-cancel-button"
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={() => {
              void onConfirm();
            }}
            disabled={isLoading}
            data-testid="signout-confirm-button"
          >
            {isLoading ? 'Signing Out...' : 'Sign Out'}
          </Button>
        </>
      )}
    >
      <p className="text-sm text-muted-foreground" data-testid="signout-confirm-message">
        Are you sure you want to sign out?
      </p>
    </Modal>
  );
};
